module.exports = __webpack_public_path__ + "src/common/img/eps.png";